module.exports = __webpack_public_path__ + "img/lg_ring_g_e_1_0@3x.b92b5f26.png";